import React, { useState, useEffect, useRef } from "react";
import Dropdown from "react-dropdown-select";
import { useMediaQuery } from "react-responsive";
import relationshipOptions from "./data/relationshipOptions.json";
import {
  customDropdownStyles,
  dropdownContentRenderer,
  noBorderItemRenderer,
} from "../../../util_functions/helpers";

const MyContactsComponent = ({ user }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const lastContactRef = useRef(null);
  const [contacts, setContacts] = useState([
    {
      id: Date.now(),
      relationship: "",
      firstName: user?.firstName || "",
      lastName: user?.lastName || "",
      phone: "",
      email: "",
    },
  ]);

  const addContact = () =>
    setContacts((prev) => [
      ...prev,
      {
        id: Date.now(),
        relationship: "",
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
        showRemove: true,
      },
    ]);

  const updateContact = (id, field, value) =>
    setContacts((prev) =>
      prev.map((c) => (c.id === id ? { ...c, [field]: value } : c))
    );

  const removeContact = (id) =>
    setContacts((prev) => prev.filter((c) => c.id !== id));

  useEffect(() => {
    if (contacts.length > 1) {
      lastContactRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [contacts.length]);

  return (
    <div className="personal-details-container">
      <p>
        Add up to 3 contacts that support you as emergency contacts or
        authorised to receive information.
      </p>

      {contacts.map((contact, idx) => (
        <div key={contact.id} className="relationship-detail"
        ref={idx === contacts.length - 1 ? lastContactRef : null} 
        >
          <h3>Emergency contact #{idx + 1}</h3>

          <label>Relationship</label>
          <Dropdown 
            options={relationshipOptions}
            values={
              contact.relationship
                ? [{ label: contact.relationship, value: contact.relationship }]
                : []
            }
            placeholder="Select"
            onChange={(values) =>
              updateContact(contact.id, "relationship", values[0]?.value || "")
            }
            style={customDropdownStyles(isMobile)}
            dropdownStyle={customDropdownStyles(isMobile)}
            contentRenderer={dropdownContentRenderer}
            itemRenderer={noBorderItemRenderer}
          />
          <label>First name</label>
          <input
            type="text"
            value={contact.firstName}
            onChange={(e) =>
              updateContact(contact.id, "firstName", e.target.value)
            }
          />

          <label>Last name</label>
          <input
            type="text"
            value={contact.lastName}
            onChange={(e) =>
              updateContact(contact.id, "lastName", e.target.value)
            }
          />

          <label>Contact phone</label>
          <input
            type="text"
            value={contact.phone}
            onChange={(e) =>
              updateContact(contact.id, "phone", e.target.value)
            }
          />

          <label>Email (Optional)</label>
          <input
            type="email"
            value={contact.email}
            onChange={(e) =>
              updateContact(contact.id, "email", e.target.value)
            }
          />
          <div className="add-remove-buttons-wrapper">
          {(idx === 0 || idx === contacts.length - 1) && contacts.length < 3 && (
              <div className="add-person-container">
                <button onClick={addContact}>+ Add person</button>
              </div>
            )}

            {contacts.length > 1 && (
              <div className="delete-button-container">
                <button onClick={() => removeContact(contact.id)}>
                  Remove
                </button>
              </div>
            )}
          </div>
        </div>
      ))}

      <div className="work-history-save">
        <button>Save and continue</button>
      </div>
    </div>
  );
};

export default MyContactsComponent;
